import { Baby, Sunrise } from "lucide-react";
import { OpeningScroll } from "./OpeningScroll";

const plans = [
  { icon: Baby, name: "網紅親子住房專案", text: "給學齡前兒童家庭，主打史努比主題房、DIY 課程與親子設施。" },
  { icon: Sunrise, name: "退休族樂活平日專案", text: "給北部退休族，雙人房含早餐建議價 NT$3,500。" },
];

export const Hero = () => (
  <section id="goal" data-testid="hero-section" className="relative bg-[var(--warm)]">
    <OpeningScroll />
    <div className="mx-auto max-w-6xl px-5 pb-16 pt-4 md:pb-24">
      <p className="text-sm font-black tracking-widest text-[var(--muted)]">用兩個方案做到</p>
      <div className="mt-4 grid gap-4 md:grid-cols-2">
        {plans.map((p, i) => (
          <div key={p.name} data-testid={`hero-plan-${i}`} className="flex gap-4 rounded-2xl border border-[var(--line)] bg-white p-6">
            <div className="grid h-12 w-12 shrink-0 place-items-center rounded-xl bg-[var(--orange)] text-white"><p.icon size={22} /></div>
            <div>
              <h2 className="text-base font-bold text-[var(--ink)] md:text-lg">{p.name}</h2>
              <p className="mt-1 text-sm text-[var(--text)] md:text-base">{p.text}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  </section>
);
